import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  containerTrades: {
    maxWidth: 340,
    minWidth: 320,
    height: "auto",
    paddingHorizontal: 25,
    paddingVertical: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  titleOrdersAndTrade: {
    fontWeight: "bold",
    color: "#077A97",
    fontSize: 18,
    marginBottom: 6,
  },

  contentOrders: {
    flexDirection: "row",
  },

  orderPurchases: {
    fontSize: 12,
  },

  orderPurchasesBold: {
    fontSize: 12,
    fontWeight: "bold",
  },

  hr: {
    height: 2,
    marginTop: 10,
    backgroundColor: "#077A97",
    opacity: 0.3,
  },

  contentDescriptionOrders: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 55,
    paddingVertical: 5,
  },

  ordersTitle: {
    fontSize: 10,
    fontWeight: "300",
    textTransform: "uppercase",
    color: "#2C2C2E",
  },

  contentPurchaseOrSale: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  contentPurchaseOrSale: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  amountPurchase: {
    fontSize: 12,
  },

  pricePurchase: {
    fontSize: 12,
    color: "green",
  },
  noOrdersMessage: {
    textAlign: "center",
    fontSize: 14,
    color: "#888",
    marginTop: 20,
  },
});
export default styles;
